/**
 * Format date for display - handles both BS string dates and old Date objects
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string (YYYY-MM-DD)
 */
export const formatDateDisplay = (date) => {
  if (!date) return '';
  
  // If it's already a string in YYYY-MM-DD format, return as is
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  
  // If it's a Date object or timestamp, convert to YYYY-MM-DD
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return String(date);
    return d.toISOString().split('T')[0];
  } catch {
    return String(date);
  }
};

/**
 * Get current Nepali (BS) date in YYYY-MM-DD format
 * @returns {string} Current BS date
 */
export const getCurrentBSDate = () => {
  try {
    // Use nepali-date-converter to get current BS date
    const NepaliDate = require('nepali-date-converter').default;
    const today = new NepaliDate();
    const year = today.getYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error getting BS date:', error);
    // Fallback to AD date if BS conversion fails
    return new Date().toISOString().split('T')[0];
  }
};
